import React from 'react';
import { Autocomplete, TextField, Avatar, Box, Typography, Chip } from '@mui/material';
import { GameCssStyles } from '../../GameManagement/GameCssStyles';

const MultiSelectDropdownWithImages = ({ value, artists, onChange }) => {
  return (
    <Autocomplete
      fullWidth
      multiple
      options={artists}
      getOptionLabel={(option) => option.displayName}
      value={value}
      onChange={(event, newValue) => onChange(event, newValue)}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      renderInput={(params) => (
        <TextField 
        {...params} 
        label="Select Entities" 
        placeholder="Search..." 
        sx={GameCssStyles.formSingleLineTextField_sx}
        />
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* <Avatar src={option.image} alt={option.label} /> */}
          <Typography>{option.displayName}</Typography>
        </Box>
      )}
       renderTags={(selected, getTagProps) =>
        selected.map((option, index) => (
          <Chip
            key={option._id}
            {...getTagProps({ index })}
            // avatar={<Avatar src={option.image} />}
            label={option.displayName}
          />
        ))
      }
      //sx={{ width: 400 }}
    />
  );
};

export default MultiSelectDropdownWithImages;
